$(document).ready(function(){

	
	//
	var $contGallery = $('.gallery');
	
	$contGallery.imagesLoaded( function(){
			 
		$contGallery.isotope(
		{
			itemSelector: '.gallery-item',
			layoutMode: 'fitRows'
		});
		
	});

	
	//
	var $contFolder = $('.folder');
	
	$contFolder.imagesLoaded( function(){
			 
		$contFolder.isotope(
		{
			itemSelector: '.folder-item',
			layoutMode: 'fitRows'
		});
		
	});
	


});